import React from "react";

//import Congrats from './congrats.svg'
import { getCongratsImage } from "../Branding";

export const FinalPage = ({_isAssessed, onClick = ()=> {}}) => {

    const Congrats = getCongratsImage()

    return (
        <div
            className="container-fluid d-flex justify-content-center align-items-center overflow-hidden p-0"
        >
            <Congrats className="img-fluid" width={undefined} height={undefined}
                style={{maxHeight: "calc(100dvh - 280px)", cursor: "pointer" }}
                preserveAspectRatio="xMidYMid meet"
                onClick={onClick}
            />
        </div>
    )

}